import { RiEditLine, RiInstanceLine } from 'react-icons/ri';

import ToggleActive from '@lib/core/src/components/ToggleActive';
import palette from '@lib/core/src/theme/palette';

import {
  AgentConfigType,
  AgentsListConfig
} from '@/components/Agents/AgentConfig/AgentsListConfig';

import {
  CapabilityRow,
  Cell,
  Text,
  SmallText,
  IconButton,
  Row,
  NameStack,
  IconContainer
} from './MyCapabilitiesStyles';

interface LegacyAgentRowProps {
  id: string;
  name: string;
  description: string;
  trigger: string;
  lastEdited: string;
  enabled: boolean;
  setSelectedNativeAgent: (agent: AgentConfigType) => void;
  handleToggle: (agentKey: string | undefined, enabled: boolean) => void;
}
const LegacyAgentRow = ({
  id,
  name,
  description,
  trigger,
  lastEdited,
  enabled,
  setSelectedNativeAgent,
  handleToggle
}: LegacyAgentRowProps) => {
  const onEdit = (id: string | undefined) => {
    if (!id) return;
    const nativeAgent = AgentsListConfig.find(agent => agent.activeKey === id);
    if (nativeAgent) {
      setSelectedNativeAgent(nativeAgent);
    }
  };

  return (
    <CapabilityRow onClick={() => onEdit(id)}>
      <Cell>
        <Row>
          <IconContainer>
            <RiInstanceLine size={20} color={palette.grey[500]} />
          </IconContainer>
          <NameStack>
            <Text>{name}</Text>
            <SmallText>{description}</SmallText>
          </NameStack>
        </Row>
      </Cell>
      <Cell>
        <Text>{trigger}</Text>
      </Cell>
      <Cell>
        <ToggleActive
          active={enabled}
          onChange={(isActive, e) => {
            e?.stopPropagation();
            handleToggle(id, isActive);
          }}
        />
      </Cell>
      <Cell>
        <Text>{lastEdited}</Text>
      </Cell>
      <Cell>
        <IconButton
          onClick={() => onEdit(id)}
          aria-label="Edit"
          style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: 8 }}
        >
          <RiEditLine size={16} color={palette.grey[500]} />
        </IconButton>
      </Cell>
    </CapabilityRow>
  );
};

export default LegacyAgentRow;
